interface RatioBarProps {
  /** Numerator (e.g. active accounts). */
  value: number;
  /** Denominator (e.g. total accounts). */
  total: number;
  /** Left-hand legend text. */
  caption?: string;
  className?: string;
}

/**
 * Single progress/ratio bar (value / total) with a percentage legend.
 * Fill uses the primary token; the track uses muted. Guards total === 0.
 */
export function RatioBar({ value, total, caption, className }: RatioBarProps) {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;

  return (
    <div className={className}>
      <div className="h-2.5 w-full overflow-hidden rounded-full bg-muted" role="img" aria-label={`${pct}%`}>
        <div className="h-full rounded-full" style={{ width: `${pct}%`, background: 'var(--primary)' }} />
      </div>
      <div className="mt-1.5 flex justify-between text-[11px] text-muted-foreground">
        {caption && <span>{caption}</span>}
        <span className="font-semibold text-foreground">{pct}%</span>
      </div>
    </div>
  );
}
